import React, { useState } from 'react';
import { TextField } from '@mui/material';

const FilterTextField = (props) => {
  const {
    onFilterChanged,
    columnDef,
    defaultFilter = null,
    numeric = false,
    isInteger = false,
    ...rest
  } = props;
  const [selectedVal, setSelectedVal] = useState(defaultFilter || '');

  const handleChange = (e) => {
    const val = e.target.value;
    if (numeric && isNaN(val)) {
      // do nothing
    } else if (isInteger && !new RegExp('^$|^\\d+$').test(val)) {
      // do nothing
    } else {
      setSelectedVal(val);
      onFilterChanged(columnDef.tableData.id, val);
    }
  };

  return (
    <TextField
      {...rest}
      variant="outlined"
      value={selectedVal ?? ''}
      onChange={handleChange}
      defaultValue=""
    />
  );
};

export default FilterTextField;
